export interface QuestStep {
  id: number;
  title: string;
  description: string;
  page: string;
  target?: string; // CSS selector for spotlight
  completionAction: string;
  celebrationTitle: string;
  celebrationDescription: string;
  nextStepHint?: string;
}

export interface QuestState {
  currentStep: number;
  isActive: boolean;
  isCompleted: boolean;
  completedSteps: number[];
  lastActionWasSkip: boolean;
}

export interface QuestContextType {
  questState: QuestState;
  currentQuestStep: QuestStep | null;
  completeQuest: (stepId: number) => Promise<void>;
  startQuest: () => Promise<void>;
  skipQuest: () => Promise<void>;
  skipCurrentStep: () => Promise<void>;
  isStepCompleted: (stepId: number) => boolean;
  getNextIncompleteStep: () => QuestStep | null;
  isOnCorrectPage: (step: QuestStep) => boolean;
  getCurrentQuestStepWithResolvedUrl: () => Promise<QuestStep | null>;
  canProgressToProjectSteps: () => Promise<boolean>;
  getUserFirstProjectId: () => Promise<string | null>;
  isLoading: boolean;
}

export interface QuestOverlayProps {
  isVisible: boolean;
  questStep: QuestStep;
  onComplete: () => void;
  onSkip: () => void;
}

export interface QuestTooltipProps {
  questStep: QuestStep;
  onComplete: () => void;
  onSkip: () => void;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

export interface QuestProgressProps {
  currentStep: number;
  totalSteps: number;
  completedSteps: number[];
}

export interface SpotlightHighlightProps {
  target: string;
  isVisible: boolean;
}

export interface QuestCelebrationProps {
  isVisible: boolean;
  questStep: QuestStep;
  onContinue: () => void;
}

export type QuestStepId = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const QUEST_STEP_IDS = {
  CREATE_PAGE: 1,
  GENERATE_RESEARCH: 2,
  GENERATE_IMAGE: 3,
  CREATE_PROJECT: 4,
  ADD_TASK: 5,
  IMPORT_PAGE: 6,
  IMPORT_RESEARCH: 7,
  ADD_TEAM_MEMBER: 8,
} as const;